import { getButtonStyleVariantValues, themeButtons } from 'shared/design-system/theme/buttons';
import styled, { css } from 'styled-components';
import colors from 'theme/colors';

export const StyledImg = styled.img`
  max-height: 48px;
  position: relative;
  top: 6px;
`;

export const AppIconWrapper = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 8px;
  background: ${colors.white};
  box-shadow: ${({ theme }) => theme.elevations.low};
`;

export const CloseBannerButton = styled.button`
  display: flex;
  padding: 0;
  cursor: pointer;
  border: none;
  svg {
    min-width: 16px;
    min-height: 16px;
  }
`;

export const ButtonStyledWrapper = styled.div`
  ${({ theme }) => {
    const { border, borderActive, borderHover } = getButtonStyleVariantValues(
      theme,
      themeButtons,
      'secondary',
    );
    return css`
      display: flex;
      button {
        padding: 4px 24px;
        height: 32px;
        border: ${border};
        border-width: 2px;

        &:hover {
          border: ${borderHover};
          border-width: 2px;
        }

        &:active {
          border: ${borderActive};
          border-width: 2px;
        }
      }
    `;
  }}
`;

export const BannerTextContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;

  p {
    font-size: 16px;
    line-height: 24px;
  }

  sub {
    font-size: 12px;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.medium}) {
    p {
      font-size: 14px;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    sub {
      font-size: 14px;
    }
  }
`;

export const BannerLeftContent = styled.div`
  display: flex;
  width: fit-content;
  margin-right: auto;
  align-items: inherit;
  gap: 12px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.small}) {
    gap: 8px;
  }
`;

export const BannerWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    padding: 12px 24px;
    align-items: center;
    background: ${theme.colors.strokeSecondaryGrey10};

    // position the banner at the top of the layout (disregard layout padding)
    position: relative;
    width: calc(100% + 96px);
    top: -44px;

    @media screen and (max-width: ${theme.breakpoints.large}) {
      top: -34px;
      width: calc(100% + 64px);
    }

    @media screen and (max-width: ${theme.breakpoints.medium}) {
      padding: 12px 12px 12px 16px;
    }

    @media screen and (max-width: ${theme.breakpoints.small}) {
      padding: 12px 8px;
      top: -20px;
      width: calc(100% + 32px);
    }
  `}
`;
